// src/helpers/pushSupport.js
export function supportsWebPush() {
    if (typeof window === "undefined") return false;
  
    const hasSW = "serviceWorker" in navigator;
    const hasNotification = typeof Notification !== "undefined";
  
    // iOS: Web Push works only for installed PWAs (iOS 16.4+)
    const ua = navigator.userAgent || "";
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isStandalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      navigator.standalone === true;
  
    return hasSW && hasNotification && (!isIOS || isStandalone);
  }